export const schoolClassAccessKeys = {
  all: ['schoolClassAccess'],

  lists: () => [...schoolClassAccessKeys.all, 'list'],

  accessRightsList: () => [...schoolClassAccessKeys.lists(), 'accessRights'],

  invitationAccessRightsList: () => [...schoolClassAccessKeys.lists(), 'invitationAccessRights'],

  class: (classId?: number) => [...schoolClassAccessKeys.all, 'class', classId ?? null],

  classAccessRights: (classId?: number) => [...schoolClassAccessKeys.class(classId), 'accessRights'],

  classInvitationsAndUsers: (classId?: number) => [...schoolClassAccessKeys.class(classId), 'invitationsAndUsers'],
};
